(function() { module.exports = window["Bernie_l10nBundle_ja_JP"]; }());